// AUTO-GENERATED by scripts/generateTypes.ts — do not edit by hand.
// Run `pnpm i18n:gen-types` to regenerate. Source language = es.
import esAccessControl from './locales/es/accessControl.json';
import esAlerts from './locales/es/alerts.json';
import esBenefits from './locales/es/benefits.json';
import esCommon from './locales/es/common.json';
import esCompanySettings from './locales/es/companySettings.json';
import esCompanySwitch from './locales/es/companySwitch.json';
import esEndUsers from './locales/es/endUsers.json';
import esErrors from './locales/es/errors.json';
import esFrekuentSpots from './locales/es/frekuentSpots.json';
import esMarketplace from './locales/es/marketplace.json';
import esNotifications from './locales/es/notifications.json';
import esPosAds from './locales/es/posAds.json';
import esPosAdsTaxonomy from './locales/es/posAdsTaxonomy.json';
import esPosPersonalization from './locales/es/posPersonalization.json';
import esProducts from './locales/es/products.json';
import esProfile from './locales/es/profile.json';
import esReports from './locales/es/reports.json';
import esSupport from './locales/es/support.json';
import esTransactions from './locales/es/transactions.json';
import enAccessControl from './locales/en/accessControl.json';
import enAlerts from './locales/en/alerts.json';
import enBenefits from './locales/en/benefits.json';
import enCommon from './locales/en/common.json';
import enCompanySettings from './locales/en/companySettings.json';
import enCompanySwitch from './locales/en/companySwitch.json';
import enEndUsers from './locales/en/endUsers.json';
import enErrors from './locales/en/errors.json';
import enFrekuentSpots from './locales/en/frekuentSpots.json';
import enMarketplace from './locales/en/marketplace.json';
import enNotifications from './locales/en/notifications.json';
import enPosAds from './locales/en/posAds.json';
import enPosAdsTaxonomy from './locales/en/posAdsTaxonomy.json';
import enPosPersonalization from './locales/en/posPersonalization.json';
import enProducts from './locales/en/products.json';
import enProfile from './locales/en/profile.json';
import enReports from './locales/en/reports.json';
import enSupport from './locales/en/support.json';
import enTransactions from './locales/en/transactions.json';
import ptAccessControl from './locales/pt/accessControl.json';
import ptAlerts from './locales/pt/alerts.json';
import ptBenefits from './locales/pt/benefits.json';
import ptCommon from './locales/pt/common.json';
import ptCompanySettings from './locales/pt/companySettings.json';
import ptCompanySwitch from './locales/pt/companySwitch.json';
import ptEndUsers from './locales/pt/endUsers.json';
import ptErrors from './locales/pt/errors.json';
import ptFrekuentSpots from './locales/pt/frekuentSpots.json';
import ptMarketplace from './locales/pt/marketplace.json';
import ptNotifications from './locales/pt/notifications.json';
import ptPosAds from './locales/pt/posAds.json';
import ptPosAdsTaxonomy from './locales/pt/posAdsTaxonomy.json';
import ptPosPersonalization from './locales/pt/posPersonalization.json';
import ptProducts from './locales/pt/products.json';
import ptProfile from './locales/pt/profile.json';
import ptReports from './locales/pt/reports.json';
import ptSupport from './locales/pt/support.json';
import ptTransactions from './locales/pt/transactions.json';
import itAccessControl from './locales/it/accessControl.json';
import itAlerts from './locales/it/alerts.json';
import itBenefits from './locales/it/benefits.json';
import itCommon from './locales/it/common.json';
import itCompanySettings from './locales/it/companySettings.json';
import itCompanySwitch from './locales/it/companySwitch.json';
import itEndUsers from './locales/it/endUsers.json';
import itErrors from './locales/it/errors.json';
import itFrekuentSpots from './locales/it/frekuentSpots.json';
import itMarketplace from './locales/it/marketplace.json';
import itNotifications from './locales/it/notifications.json';
import itPosAds from './locales/it/posAds.json';
import itPosAdsTaxonomy from './locales/it/posAdsTaxonomy.json';
import itPosPersonalization from './locales/it/posPersonalization.json';
import itProducts from './locales/it/products.json';
import itProfile from './locales/it/profile.json';
import itReports from './locales/it/reports.json';
import itSupport from './locales/it/support.json';
import itTransactions from './locales/it/transactions.json';
import frAccessControl from './locales/fr/accessControl.json';
import frAlerts from './locales/fr/alerts.json';
import frBenefits from './locales/fr/benefits.json';
import frCommon from './locales/fr/common.json';
import frCompanySettings from './locales/fr/companySettings.json';
import frCompanySwitch from './locales/fr/companySwitch.json';
import frEndUsers from './locales/fr/endUsers.json';
import frErrors from './locales/fr/errors.json';
import frFrekuentSpots from './locales/fr/frekuentSpots.json';
import frMarketplace from './locales/fr/marketplace.json';
import frNotifications from './locales/fr/notifications.json';
import frPosAds from './locales/fr/posAds.json';
import frPosAdsTaxonomy from './locales/fr/posAdsTaxonomy.json';
import frPosPersonalization from './locales/fr/posPersonalization.json';
import frProducts from './locales/fr/products.json';
import frProfile from './locales/fr/profile.json';
import frReports from './locales/fr/reports.json';
import frSupport from './locales/fr/support.json';
import frTransactions from './locales/fr/transactions.json';
import deAccessControl from './locales/de/accessControl.json';
import deAlerts from './locales/de/alerts.json';
import deBenefits from './locales/de/benefits.json';
import deCommon from './locales/de/common.json';
import deCompanySettings from './locales/de/companySettings.json';
import deCompanySwitch from './locales/de/companySwitch.json';
import deEndUsers from './locales/de/endUsers.json';
import deErrors from './locales/de/errors.json';
import deFrekuentSpots from './locales/de/frekuentSpots.json';
import deMarketplace from './locales/de/marketplace.json';
import deNotifications from './locales/de/notifications.json';
import dePosAds from './locales/de/posAds.json';
import dePosAdsTaxonomy from './locales/de/posAdsTaxonomy.json';
import dePosPersonalization from './locales/de/posPersonalization.json';
import deProducts from './locales/de/products.json';
import deProfile from './locales/de/profile.json';
import deReports from './locales/de/reports.json';
import deSupport from './locales/de/support.json';
import deTransactions from './locales/de/transactions.json';
import caAccessControl from './locales/ca/accessControl.json';
import caAlerts from './locales/ca/alerts.json';
import caBenefits from './locales/ca/benefits.json';
import caCommon from './locales/ca/common.json';
import caCompanySettings from './locales/ca/companySettings.json';
import caCompanySwitch from './locales/ca/companySwitch.json';
import caEndUsers from './locales/ca/endUsers.json';
import caErrors from './locales/ca/errors.json';
import caFrekuentSpots from './locales/ca/frekuentSpots.json';
import caMarketplace from './locales/ca/marketplace.json';
import caNotifications from './locales/ca/notifications.json';
import caPosAds from './locales/ca/posAds.json';
import caPosAdsTaxonomy from './locales/ca/posAdsTaxonomy.json';
import caPosPersonalization from './locales/ca/posPersonalization.json';
import caProducts from './locales/ca/products.json';
import caProfile from './locales/ca/profile.json';
import caReports from './locales/ca/reports.json';
import caSupport from './locales/ca/support.json';
import caTransactions from './locales/ca/transactions.json';

export const LANGUAGES = ['es', 'en', 'pt', 'it', 'fr', 'de', 'ca'] as const;
export const DEFAULT_LANGUAGE = 'es' as const;
export const EAGER_NAMESPACES = [
	'accessControl',
	'alerts',
	'benefits',
	'common',
	'companySettings',
	'companySwitch',
	'endUsers',
	'errors',
	'frekuentSpots',
	'marketplace',
	'notifications',
	'posAds',
	'posAdsTaxonomy',
	'posPersonalization',
	'products',
	'profile',
	'reports',
	'support',
	'transactions',
] as const;
export const LAZY_NAMESPACES = [] as const;
export const NAMESPACES = [...EAGER_NAMESPACES, ...LAZY_NAMESPACES] as const;

export type Language = (typeof LANGUAGES)[number];
export type Namespace = (typeof NAMESPACES)[number];

export const eagerResources = {
	es: {
		accessControl: esAccessControl,
		alerts: esAlerts,
		benefits: esBenefits,
		common: esCommon,
		companySettings: esCompanySettings,
		companySwitch: esCompanySwitch,
		endUsers: esEndUsers,
		errors: esErrors,
		frekuentSpots: esFrekuentSpots,
		marketplace: esMarketplace,
		notifications: esNotifications,
		posAds: esPosAds,
		posAdsTaxonomy: esPosAdsTaxonomy,
		posPersonalization: esPosPersonalization,
		products: esProducts,
		profile: esProfile,
		reports: esReports,
		support: esSupport,
		transactions: esTransactions,
	},
	en: {
		accessControl: enAccessControl,
		alerts: enAlerts,
		benefits: enBenefits,
		common: enCommon,
		companySettings: enCompanySettings,
		companySwitch: enCompanySwitch,
		endUsers: enEndUsers,
		errors: enErrors,
		frekuentSpots: enFrekuentSpots,
		marketplace: enMarketplace,
		notifications: enNotifications,
		posAds: enPosAds,
		posAdsTaxonomy: enPosAdsTaxonomy,
		posPersonalization: enPosPersonalization,
		products: enProducts,
		profile: enProfile,
		reports: enReports,
		support: enSupport,
		transactions: enTransactions,
	},
	pt: {
		accessControl: ptAccessControl,
		alerts: ptAlerts,
		benefits: ptBenefits,
		common: ptCommon,
		companySettings: ptCompanySettings,
		companySwitch: ptCompanySwitch,
		endUsers: ptEndUsers,
		errors: ptErrors,
		frekuentSpots: ptFrekuentSpots,
		marketplace: ptMarketplace,
		notifications: ptNotifications,
		posAds: ptPosAds,
		posAdsTaxonomy: ptPosAdsTaxonomy,
		posPersonalization: ptPosPersonalization,
		products: ptProducts,
		profile: ptProfile,
		reports: ptReports,
		support: ptSupport,
		transactions: ptTransactions,
	},
	it: {
		accessControl: itAccessControl,
		alerts: itAlerts,
		benefits: itBenefits,
		common: itCommon,
		companySettings: itCompanySettings,
		companySwitch: itCompanySwitch,
		endUsers: itEndUsers,
		errors: itErrors,
		frekuentSpots: itFrekuentSpots,
		marketplace: itMarketplace,
		notifications: itNotifications,
		posAds: itPosAds,
		posAdsTaxonomy: itPosAdsTaxonomy,
		posPersonalization: itPosPersonalization,
		products: itProducts,
		profile: itProfile,
		reports: itReports,
		support: itSupport,
		transactions: itTransactions,
	},
	fr: {
		accessControl: frAccessControl,
		alerts: frAlerts,
		benefits: frBenefits,
		common: frCommon,
		companySettings: frCompanySettings,
		companySwitch: frCompanySwitch,
		endUsers: frEndUsers,
		errors: frErrors,
		frekuentSpots: frFrekuentSpots,
		marketplace: frMarketplace,
		notifications: frNotifications,
		posAds: frPosAds,
		posAdsTaxonomy: frPosAdsTaxonomy,
		posPersonalization: frPosPersonalization,
		products: frProducts,
		profile: frProfile,
		reports: frReports,
		support: frSupport,
		transactions: frTransactions,
	},
	de: {
		accessControl: deAccessControl,
		alerts: deAlerts,
		benefits: deBenefits,
		common: deCommon,
		companySettings: deCompanySettings,
		companySwitch: deCompanySwitch,
		endUsers: deEndUsers,
		errors: deErrors,
		frekuentSpots: deFrekuentSpots,
		marketplace: deMarketplace,
		notifications: deNotifications,
		posAds: dePosAds,
		posAdsTaxonomy: dePosAdsTaxonomy,
		posPersonalization: dePosPersonalization,
		products: deProducts,
		profile: deProfile,
		reports: deReports,
		support: deSupport,
		transactions: deTransactions,
	},
	ca: {
		accessControl: caAccessControl,
		alerts: caAlerts,
		benefits: caBenefits,
		common: caCommon,
		companySettings: caCompanySettings,
		companySwitch: caCompanySwitch,
		endUsers: caEndUsers,
		errors: caErrors,
		frekuentSpots: caFrekuentSpots,
		marketplace: caMarketplace,
		notifications: caNotifications,
		posAds: caPosAds,
		posAdsTaxonomy: caPosAdsTaxonomy,
		posPersonalization: caPosPersonalization,
		products: caProducts,
		profile: caProfile,
		reports: caReports,
		support: caSupport,
		transactions: caTransactions,
	},
} as const;
